exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summarySection__wrapper___39oFu {\n  background-color: #f3f3f3; }\n  .summarySection__wrapper___39oFu .summarySection__summarySection___ufyQF {\n    background-color: #fff;\n    padding: 23px 15px 15px; }\n    .summarySection__wrapper___39oFu .summarySection__summarySection___ufyQF.summarySection__disabled___OqUUh {\n      pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "summarySection__wrapper___39oFu",
	"summarySection": "summarySection__summarySection___ufyQF",
	"disabled": "summarySection__disabled___OqUUh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/summarySection.scss
// module id = 4320
// module chunks = 6